import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { FolderCreatePayload } from 'Interfaces/Folder';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: FolderCreatePayload) =>
    $actions.folder.createFolder(dispatch, values),
  );
};
